export enum UIStateEnum
{
  ShowLoading = 1,
  ShowError = 2,
  ShowData = 3,
  ShowRequestProcessing = 4
}
